import React from "react";
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
} from "@material-ui/lab";

import { Typography } from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUniversity,
  faMapMarker,
  faCalendar,
} from "@fortawesome/free-solid-svg-icons";

export default () => {
  return (
    <Timeline align="left">
      <TimelineItem>
        <TimelineSeparator>
          <TimelineDot color="primary">
            <FontAwesomeIcon icon={faUniversity} size="2x" />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>
          <Typography variant="h5" component="h1">
            B.Sc. in Electrical Engineering
          </Typography>
          <Typography variant="subtitle2">
            <FontAwesomeIcon icon={faMapMarker} /> Shahid Beheshti University{" "}
            <br />
            <FontAwesomeIcon icon={faCalendar} /> 2018 - Present
            <br />
            <a href="http://en.sbu.ac.ir/SitePages/Home.aspx">Website</a>
            <br />
            GPA: 3.74
          </Typography>
        </TimelineContent>
      </TimelineItem>

      <TimelineItem>
        <TimelineSeparator>
          <TimelineDot color="primary">
            <FontAwesomeIcon icon={faUniversity} size="2x" />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>
          <Typography variant="h5" component="h1">
            Diploma in Mathematics and Physics Discipline
          </Typography>
          <Typography variant="subtitle2">
            <FontAwesomeIcon icon={faMapMarker} /> SanieFar Highschool <br />
            <FontAwesomeIcon icon={faCalendar} /> 2014 - 2018
            <br />
            <a href="http://saniefarnemoone.ir/">Website</a> <br />
          </Typography>
        </TimelineContent>
      </TimelineItem>
    </Timeline>
  );
};
